import { Loader2Icon } from 'lucide-react';
import * as React from 'react';

import { cn } from '@ui/lib/utils';

const Spinner = ({ className, ...props }: React.ComponentProps<'svg'>) => {
  return (
    <Loader2Icon
      data-slot="spinner"
      role="status"
      aria-label="Loading"
      className={cn('size-4 animate-spin', className)}
      {...props}
    />
  );
};

export { Spinner };
